import { z } from 'zod';

export const PayOrderResponseSchema = z.object({
  hash: z.string(),
  sessionId: z.string(),
});
